// 应用入口：运营平台全站强制真实后端（mock 已移除，USE_MOCK 恒 false）；类型见 @/types
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
